export const Units = {
    update: function (el, binding) {
        handleBinding(el, binding);
    },

    bind: function (el, binding) {
        handleBinding(el, binding);
    }
};

function handleBinding (el, binding) {
    let unitsValue = binding.value;

    if (unitsValue === '₽') {
        unitsValue = 'р';
    }

    let canvas = document.createElement('canvas');

    let context = canvas.getContext('2d');
    context.font = "16px Arial";

    let unitsWidth = Math.round(context.measureText(unitsValue).width);
    context = null;
    canvas = null;

    Object.assign(el.style, {
        paddingRight: (unitsWidth + 4) + 'px',
        backgroundSize: 'auto',
        backgroundPosition: 'right bottom',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url("data:image/svg+xml;utf8,` +
            `<svg xmlns='http://www.w3.org/2000/svg' width='` + (unitsWidth + 4) + `px' height='20px'>` +
            `<text x='` + (unitsWidth + 2) + `px' y='15px' fill='gray' font-size='16px' font-family='Arial, sans-serif' text-anchor='end'>` + unitsValue + `</text>` +
            `</svg>")`
    });
}
